import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import SectionsUpper from '@/pages/home/components/SectionsUpper';
import SectionsLower from '@/pages/home/components/SectionsLower';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionsUpper />
        <SectionsLower />
      </main>
      <Footer />
    </div>
  );
}